'use strict';

require('../modules/models/socialHandle.js');
require('../modules/models/socialChannel.js');
require('../modules/collections/socialHandles.js');
require('../modules/collections/socialChannels.js');
